/**
 * Semantic Focus Ring Token — consistent focus indicators.
 */

export const focusRing = {
  color: "var(--sem-border-focus)",
  width: "2px",
  offset: "2px",
  style: "solid",
} as const;
